/* Productos en vivo desde Shopify. En la tienda, el tema escribe window.SHOP_PRODUCTS con lo que hay publicado
   (precio, tallas, stock, fotos, colecciones). Aquí se mezcla con data.js/amator.js, que solo aportan lo que Shopify no tiene:
   etiquetas y notas de las palas, recortes sin fondo y textos cortos. En local (sin Shopify) no hace nada. */
(() => {
  const S = window.SHOP_PRODUCTS; if (!Array.isArray(S) || !S.length) return;
  const local = {}; (window.PRODUCTS || []).forEach(p => { local[p.h] = p; });
  const KEEP_IMG = new Set(["zip-navy-legacy", "zip-beige-legacy", "legacy-white-tee", "legacy-navy-tee"]); // fotos con el fondo ya limpiado
  const kindOf = (sp, lp) => {
    if (lp && lp.k) return lp.k;
    const c = sp.c || [], t = (sp.type || "").toLowerCase();
    if (c.includes("palas-de-padel") || /pala/.test(t)) return "pala";
    if (c.includes("paleteros") || /paletero|mochila/.test(t)) return "paletero";
    if (c.includes("sudaderas") || /sudadera|hoodie|crewneck/.test(t + " " + sp.t.toLowerCase())) return "sudadera";
    if (c.includes("polos") || /polo/.test(t)) return "polo";
    if (c.includes("camisetas") || /camiseta|tee/.test(t + " " + sp.t.toLowerCase())) return "camiseta";
    return "accesorio";
  };
  const gift = (window.SECCO_GATE && window.SECCO_GATE.gift) || "elite-squeeze-bottle";
  const out = S.map(sp => {
    const lp = local[sp.h] || {};
    const k = kindOf(sp, lp);
    const p = Object.assign({}, lp, { h: sp.h, t: sp.t, k, price: sp.price || 0, sub: lp.sub || "" });
    // tallas: en las palas se conservan los nombres bonitos («Hombre · 355-375 g») si cuadran
    p.v = sp.v.map((v, i) => ({ t: lp.v && lp.v[i] && lp.v.length === sp.v.length && k === "pala" ? lp.v[i].t : (v.t === "Default Title" ? "" : v.t), ok: !!v.ok }));
    if (sp.v.length === 1) p.one = true;
    p.img = KEEP_IMG.has(sp.h) && lp.img ? lp.img : (sp.img && sp.img.length ? sp.img : (lp.img || []));
    p.soldout = !sp.av;
    if ((sp.c || []).includes("amator")) { p.coll = "amator"; p.badge = "AMATOR"; }
    if (sp.h === gift) { p.coll = "amator"; p.badge = "AMATOR"; p.gift = true; p.one = true; }
    if (!p.price && !p.gift) p.soon = true;
    if (!p.desc && p.coll === "amator" && sp.d) p.desc = sp.d;
    return p;
  });
  // orden: AMATOR primero, luego el orden de siempre y al final lo nuevo
  const order = (window.PRODUCTS || []).map(p => p.h);
  out.sort((a, b) => (b.coll === "amator") - (a.coll === "amator") || ((order.indexOf(a.h) + 1 || 999) - (order.indexOf(b.h) + 1 || 999)));
  window.PRODUCTS = out;
  window.AMATOR = out.filter(p => p.coll === "amator");
})();
